import { FrontSide, PlaneGeometry, ShaderMaterial, Vector3, Vector4 } from "three";

export const CIRCULAR_LINES_FRAGMENT = `
    uniform float alpha;
    uniform vec4 resolution;
    uniform float time;
    uniform float timeInside;
    uniform float timeOutside;
    uniform float speed;
    uniform int numLines;
    uniform float lineLength;
    uniform float lineThickness;
    uniform float lineDistance;
    uniform float centerX;
    uniform float centerY;
    uniform vec3 lineColor;
    uniform float distanceVariation; // Amplitud de variación de la distancia
    uniform float lengthVariation;   // Amplitud de variación de la longitud
    varying vec2 vUv;
    
    void main() {
        vec2 center = vec2(centerX, centerY);
        vec2 aspectRatio = vec2(resolution.x / resolution.y, 1.0);
        vec2 pos = (vUv - 0.5) * 2.0;
        pos.x *= aspectRatio.x;
        
        // Recalcular la distancia
        float angleStep = 3.14159265359 * 2.0 / float(numLines);
        float minDist = 1.0;
        
        // Ajustar las coordenadas para que se dibujen las líneas correctamente
        for (int i = 0; i < 360; i++) {
            if (i >= numLines) break;
            
            float angle = float(i) * angleStep + time * speed;
            vec2 dir = vec2(cos(angle), sin(angle));
            dir.x *= aspectRatio.x;
            dir = normalize(dir);
            
            vec2 start = (center - 0.5) * 2.0;
            start.x *= aspectRatio.x;
            
            // Variación sinusoidal de la distancia
            float currentDistance = lineDistance + sin(angle * 2.0 + timeInside) * distanceVariation;
            
            // Ajustar la distancia desde el centro
            vec2 centerPos = start;
            vec2 lineStart = centerPos + dir * (currentDistance / resolution.y);
            
            // Variación sinusoidal de la longitud
            float currentLength = lineLength + sin(angle * 3.0 + timeOutside * 0.5) * lengthVariation;
            
            // Proyección ajustada en la dirección
            float proj = dot(pos - lineStart, dir);
            vec2 closestPoint = lineStart + dir * clamp(proj, 0.0, currentLength / resolution.y);
            float dist = length(pos - closestPoint);
            minDist = min(minDist, dist);
        }
        
        // Umbral para la visibilidad de las líneas
        float alphaLine = smoothstep(lineThickness / resolution.y, 0.0, minDist);
        
        // Si alpha es muy bajo, hacer el fragmento completamente transparente
        if (alphaLine < 0.01) discard;
        
        gl_FragColor = vec4(lineColor, alpha);
    }
`;

export const CIRCULAR_LINES_VERTEX = `
    varying vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const CIRCULAR_LINES_GEOMETRY = new PlaneGeometry(1, 1, 1, 1);

export const CIRCULAR_LINES_MATERIAL = new ShaderMaterial({
    side: FrontSide,
    transparent: true,
    depthWrite: false, // Asegura que la transparencia funcione correctamente
    uniforms: {
        time: { value: 0 },
        alpha: { value: 0 },
        timeInside: { value: 0 },
        timeOutside: { value: 0 },
        speed: { value: 1.0 }, // Velocidad de rotación
        numLines: { value: 30 },
        lineLength: { value: 400 },
        lineThickness: { value: 4 },
        lineDistance: { value: 200 }, // Nueva distancia desde el centro
        centerX: { value: 0.5 }, // Coordenada X del centro
        centerY: { value: 0.5 }, // Coordenada Y del centro
        resolution: { value: new Vector4() },
        lineColor: { value: new Vector3(0.2, 0.48, 0.52) }, // Color blanco por defecto
        distanceVariation: { value: 50.0 }, // Amplitud de la variación de distancia
        lengthVariation: { value: 100.0 },  // Amplitud de la variación de longitud
    },
    fragmentShader: CIRCULAR_LINES_FRAGMENT,
    vertexShader: CIRCULAR_LINES_VERTEX,
});
